const { getCloudflareUrl } = require('@aboutdotme/image-helpers')
const { isVideoType } = require('lib/video')
const log = require('log').create('get_portfolio_thumb_url') // eslint-disable-line
const config = require('lib/config')

const SIZE = 80

function getPortfolioThumbUrl(item, globals) {
    if (__DEBUG__) {
        if (typeof globals !== 'object') {
            throw new Error('globals must be passed in for this method to be isomorphic')
        }
    }

    if (isVideoType(item.type)) {
        return item.video_thumbnail
    }

    return getCloudflareUrl(item, {
        width: SIZE,
        height: SIZE,
        quality: 80,
        devicePixelRatio: 2,
        image_domain: config.get('pumpkinhead.globals.aws_images'),
    })

}

module.exports = {
    getPortfolioThumbUrl,
}
